import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Award, Share2, Truck, Wallet, ArrowUpRightSquare } from "lucide-react";

const STEPS = [
  {
    n: "01", icon: Award, title: "Become a Partner",
    body: "Choose a Business Starter Kit that matches your goals. Activate your account and receive your personal online store, affiliate dashboard, and AI toolkit.",
    detail: [
      "Register in under 2 minutes",
      "Instant access to your store",
      "Verify your identity for priority payouts",
    ],
  },
  {
    n: "02", icon: Share2, title: "Share & Sell",
    body: "Promote products using your unique affiliate link. Use our ready-made marketing materials, AI-generated captions, and video scripts. Take customer orders from anywhere.",
    detail: [
      "Copy-paste marketing assets",
      "AI content in seconds",
      "One-click store sharing (FB, TikTok, Messenger)",
    ],
  },
  {
    n: "03", icon: Truck, title: "We Fulfill",
    body: "Zenith ships directly to your customers. You never touch inventory. Every order status update lands in your dashboard automatically.",
    detail: [
      "Nationwide delivery",
      "Real-time tracking",
      "No warehousing or packing on your end",
    ],
  },
  {
    n: "04", icon: Wallet, title: "Earn & Withdraw",
    body: "Retail profit + referral commissions + leadership rewards accumulate in your Commission Wallet. Withdraw to your bank or e-wallet anytime.",
    detail: [
      "Retail margin on every sale",
      "10% direct referral bonus (illustrative)",
      "Team overrides down to 5 levels deep",
    ],
  },
];

export default function HowItWorks() {
  return (
    <div className="space-y-10" data-testid="how-it-works-page">
      <div>
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#FBBF24] font-bold mb-3">
          <Sparkles size={12} /> How It Works
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight max-w-3xl">
          Four steps from{" "}
          <span className="text-[#FBBF24]">activation to your first sale.</span>
        </h1>
        <p className="text-white/70 max-w-3xl mt-5 leading-relaxed">
          Zenith Flow Dynamics is designed so any Filipino with a phone and an internet connection
          can start a real online business — with real products, real customers, and real commission.
        </p>
      </div>

      <div className="space-y-5">
        {STEPS.map((s, i) => (
          <div key={s.n} className="glass-card gold-border p-6 md:p-8 flex flex-col md:flex-row gap-6" data-testid={`how-detail-step-${i + 1}`}>
            <div className="md:w-32 shrink-0">
              <div className="text-[#FBBF24] font-mono-num text-5xl md:text-6xl font-black opacity-40">{s.n}</div>
              <s.icon size={26} className="text-[#FBBF24] mt-3" />
            </div>
            <div className="flex-1">
              <div className="font-display text-2xl md:text-3xl font-black">{s.title}</div>
              <p className="text-white/75 mt-3 leading-relaxed">{s.body}</p>
              <ul className="mt-5 grid gap-2 sm:grid-cols-3 text-sm text-white/65">
                {s.detail.map((d) => (
                  <li key={d} className="flex items-start gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FBBF24] mt-2 shrink-0" /> {d}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center pt-6">
        <Link to="/register" className="btn-deploy inline-flex items-center gap-2 px-8 py-3 rounded-md text-sm font-bold uppercase tracking-widest" data-testid="how-it-works-final-cta">
          <ArrowUpRightSquare size={16} /> Start Your Business Today
        </Link>
      </div>
    </div>
  );
}
